import { useState, useEffect, useRef, useMemo } from "react"
import { Link, useNavigate } from "react-router-dom"
import { FaEdit, FaTrash } from "react-icons/fa";
import { toast } from 'react-toastify'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Server from "../../Shared/Server"
import Spinner from '../../Shared/Spinner'

import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const Motors = () => {
    const [motors, setMotors] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)
    const [show, setShow] = useState(false);
    const [publicID, setPublicID] = useState()
    const gridRef = useRef();

    const navigate = useNavigate()

    useEffect(() => {
        let isMounted = true
        const getMotors = async () => {
            setIsLoading(true)
            try {
                const response = await Server.get('/motors/')
                if(isMounted){
                    setMotors(response?.data)
                }
                setIsLoading(false)
            } catch (error) {
                setIsLoading(false)
                if(error?.response?.status === 401){
              localStorage.removeItem('user')
              navigate('/login')
          }else if (error?.response?.status === 403){
            toast.error(error?.response?.data?.detail || 'Forbidden');
            navigate('/');
          }else {
            toast.error(error?.response?.data?.detail || 'Failed to load motors')
          }
            }
        }


        getMotors()
        return () => (isMounted = false);
    }, [])

    const handleClose = () => {
        if (isDeleting) return
        setShow(false)
    }
    const handleShow = (public_id) => {
        setShow(true)
        setPublicID(public_id)
    };

    const handleDelete = async (public_id) => {
        setIsDeleting(true)
        try {
            const response = await Server.delete(`/motors/${public_id}`)
            if (response.status === 200){
                toast.success(response.data.detail)
                setMotors(prev => prev.filter((motor) => motor.public_id !== public_id))
            }else{
                toast.error(response?.data?.detail || 'Failed to delete motor')
            }
        } catch (error) {
            if(error?.response?.status === 401){
                navigate('/login')
            }else if (error?.response?.status === 403){
                toast.error(error?.response?.data?.detail || 'Forbidden');
                navigate('/');
            }else{
                toast.error(error?.response?.data?.detail || 'Failed to delete motor')
            }
        } finally {
            setIsDeleting(false)
            setShow(false)
        }
    }

    const defaultColDef = useMemo(() => {
        return {
            filterParams: {
                buttons: []
            }
        };
    }, []);

    const columnDefs = useMemo(() => [
        {
            headerName: "#",
            filter: false,
            maxWidth: 70,
            sortable: true,
            valueFormatter: function (params) {
            if (isNaN(params.node.id)) {
                return "";
            }
            return `${Number(params.node.rowIndex) + 1}`;
            },
        },

        {
            headerName: "Name",
            field: "name",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Power",
            field: "power",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Actions",
            pinned: 'left',
            minWidth: 120,
            sortable: false,
            filter: false,
            cellRenderer: (e) => {
                if (!e.data) return null;
                return (
                    <div className="d-flex gap-1">
                        <Link className="btn btn-outline-info" to="/update-motor" state={{ motor: e.data }} title="Edit motor"><FaEdit/></Link>
                        <button className="btn btn-outline-danger" onClick={()=> handleShow(e.data.public_id)} title="Delete motor"><FaTrash/></button>
                    </div>
                )
            },
        },
    ], []);

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    }

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="row">
            <div className="col-md-12">
                <Link to='/add-motor' className="btn btn-outline-info mb-2" style={{float: 'right'}}>Add Motor</Link>
            </div>
        </div>
        <div className="card">
        <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Motors</h3>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            defaultColDef={defaultColDef}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            suppressMenuHide={true}

                            rowData={motors}
                            domLayout={"normal"}
                            rowSelection={"multiple"}

                            animateRows={true}
                            pagination={false}
                            resizable={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}

                            ref={gridRef}
                            groupIncludeTotalFooter={false}
                            groupIncludeFooter={true}
                            columnDefs={columnDefs}
                        ></AgGridReact>{" "}
                    </div>
                    </div>
                </div>
        </div>
        </div>

        <Modal show={show} onHide={handleClose} backdrop={isDeleting ? 'static' : true}>
        <Modal.Header closeButton={!isDeleting}>
          <Modal.Title>Delete Alert</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure?</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose} disabled={isDeleting}>
            No
          </Button>
          <Button variant="danger" onClick={() => handleDelete(publicID)} disabled={isDeleting}>
            {isDeleting ? 'Deleting\u2026' : 'Yes'}
          </Button>
        </Modal.Footer>
      </Modal>
      <br/>
    </>
  )
}

export default Motors